import { gql } from '@apollo/client';

export const CREATE_DECISION_TREE = gql`
  mutation CreateDecisionTree($params: CreateDecisionTreeInput!) {
    createDecisionTree(params: $params) {
      success
      message
      errors
      data {
        id
        treeKey
        name
        description
        icon
        displayOrder
        isActive
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;

export const UPDATE_DECISION_TREE = gql`
  mutation UpdateDecisionTree($params: UpdateDecisionTreeInput!) {
    updateDecisionTree(params: $params) {
      success
      message
      errors
      data {
        id
        treeKey
        name
        description
        icon
        displayOrder
        isActive
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;

export const DELETE_DECISION_TREE = gql`
  mutation DeleteDecisionTree($params: DeleteDecisionTreeInput!) {
    deleteDecisionTree(params: $params) {
      success
      message
      errors
    }
  }
`;
